module.exports = __webpack_public_path__ + "static/media/icon_update.2fa06ae4.svg";